import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import {
  useChangeFirstFileResponsible,
  useChangeResponsible,
  useGetCustomer,
} from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
const initvalue = {
  IdS0alesOpportunities: null,
  IdResponsible: null,
};

export const ChangeResponsibleFirstFileModal = ({
  handleClose,
  show,
  idActivity,
}) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { data: customerresponsible } = useGetCustomer();
  const { mutateAsync: changeResponsible, isLoading: ChangingResponsible } =
    useChangeFirstFileResponsible();

  useEffect(() => {
    if (idActivity) {
      setForm({ ...form, IdS0alesOpportunities: idActivity });
    }
  }, [idActivity]);
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const handleChangeResponsible = async (data) => {
    await changeResponsible(data).then(setForm(initvalue));
  };
  return (
    <BootstrapModal
      modaltitle="انتخاب مسئول"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <>
        <SimpleSelect1
          label={"انتخاب مسئول پرونده"}
          res={customerResponsibleOptions}
          onChange={(e) => setForm({ ...form, IdResponsible: e.value })}
        />
        <div className="d-flex w-100 justify-content-end mt-4">
          <Button
            small="70px"
            className="p-1 mx-2"
            bgColor="#50cd89"
            color="#fff"
            onclick={() => {
              handleChangeResponsible(form);
              handleClose();
            }}
          >
            تایید
          </Button>
          <Button
            small="70px"
            className="p-1"
            bgColor="#f1416c"
            color="#fff"
            onclick={handleClose}
          >
            لغو
          </Button>
        </div>
      </>
    </BootstrapModal>
  );
};
